import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { signupUser, userSelector, clearState } from "../../User/UserSlice";
import toast from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";
import { FaArrowRight, FaLock, FaPhone, FaUser } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const SignUp = ({ onSwitchToSignIn }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const { isFetching, isSuccess, isError, errorMessage, successMessage } =
    useSelector(userSelector);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const onSubmit = (data) => {
    if (password !== confirmPassword) {
      toast.error(t("passwords_do_not_match"));
      return;
    }

    dispatch(signupUser(data));
  };

  useEffect(() => {
    return () => {
      dispatch(clearState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      toast.success(successMessage, { autoClose: 8000 });
      dispatch(clearState());
      history.push("/");
    }

    if (isError) {
      toast.error(errorMessage);
      dispatch(clearState());
    }
  }, [isSuccess, isError, dispatch, errorMessage, history, successMessage]);

  return (
    <div className="landing-signup">
      <form onSubmit={handleSubmit(onSubmit)} method="POST">
        <input
          name="userName"
          type="hidden"
          defaultValue="portal_user"
          ref={register({ required: true })}
        />
        <input
          name="role_id"
          type="hidden"
          defaultValue="1"
          ref={register({ required: true })}
        />
        <input
          name="enrollment_center_id"
          type="hidden"
          defaultValue="1"
          ref={register({ required: true })}
        />

        <div className="signup-field-grid">
          <label className="signup-field">
            <span>{t("first_name")}</span>
            <div>
              <FaUser aria-hidden="true" />
              <input
                name="firstName"
                type="text"
                required
                placeholder={t("enter_first_name")}
                autoComplete="given-name"
                ref={register({ required: true })}
              />
            </div>
          </label>
          <label className="signup-field">
            <span>{t("last_name")}</span>
            <div>
              <FaUser aria-hidden="true" />
              <input
                name="lastName"
                type="text"
                required
                placeholder={t("enter_last_name")}
                autoComplete="family-name"
                ref={register({ required: true })}
              />
            </div>
          </label>
          <label className="signup-field">
            <span>{t("phone_number")}</span>
            <div>
              <FaPhone aria-hidden="true" />
              <input
                name="phoneNumber"
                type="tel"
                required
                placeholder={t("enter_phone_number")}
                autoComplete="tel"
                ref={register({ required: true })}
              />
            </div>
          </label>
          <label className="signup-field">
            <span>{t("email_address")}</span>
            <div>
              <FaUser aria-hidden="true" />
              <input
                name="email"
                type="email"
                required
                placeholder={t("enter_email_address")}
                autoComplete="email"
                ref={register({
                  pattern: /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/i,
                })}
              />
            </div>
          </label>
          <label className="signup-field">
            <span>{t("password")}</span>
            <div>
              <FaLock aria-hidden="true" />
              <input
                name="password"
                type="password"
                required
                placeholder={t("create_password_placeholder")}
                autoComplete="new-password"
                onChange={(event) => setPassword(event.target.value)}
                ref={register({ required: true })}
              />
            </div>
          </label>
          <label className="signup-field">
            <span>{t("confirm_password")}</span>
            <div>
              <FaLock aria-hidden="true" />
              <input
                name="c_password"
                type="password"
                required
                placeholder={t("confirm_password_placeholder")}
                autoComplete="new-password"
                onChange={(event) => setConfirmPassword(event.target.value)}
              />
            </div>
          </label>
        </div>

        <div className="signup-captcha">
          <ReCAPTCHA
            sitekey="6LdDLJEpAAAAAH4yHx5GfRDcvHzvaKkwx6fMtTdT"
            onChange={() => setIsCaptchaVerified(true)}
          />
        </div>
        <button
          type="submit"
          className="landing-submit"
          disabled={!isCaptchaVerified || isFetching}
          aria-busy={isFetching}
        >
          {isFetching ? (
            <>
              <span className="button-spinner" aria-hidden="true" /> {t("creating_account")}
            </>
          ) : (
            <>
              {t("create_account_btn")} <FaArrowRight aria-hidden="true" />
            </>
          )}
        </button>
        <div className="landing-signup-note">
          <span>{t("already_have_account")}</span>
          {onSwitchToSignIn ? (
            <button type="button" onClick={onSwitchToSignIn}>
              {t("sign_in_btn")} <FaArrowRight aria-hidden="true" />
            </button>
          ) : (
            <Link to="/getstarted">
              {t("sign_in_btn")} <FaArrowRight aria-hidden="true" />
            </Link>
          )}
        </div>
      </form>
    </div>
  );
};

export default SignUp;
